// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Yltd","large":"styles_large__MrVw7"};